import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave, fnGetTableById } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData, getNoSlip } from "@shared/utils/CommonUtils";
import { showPopupModal } from "@widgets/CommonModal";
import { showDialog } from "@widgets/CommonDialog";
import { global, useMenuStore } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import SnButton from "@shared/components/SnButton";
import SnTab from "@shared/components/SnTab";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SN_PRD_WMO_REG_001_CHEM_POP_001 from "./SN_PRD_WMO_REG_001_CHEM_POP_001";
interface Props {
  Menuprops: menuInfo;
}

const SN_PRD_WMO_REG_001_CHEM = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
    grid4: React.createRef(),
  });
  const isRestoring = useRef(false);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    grid4: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    grid4: [],
    paramInfo: [],
  });
  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)

    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const { userInfo } = global();
  const { menuItems } = useMenuStore();
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const selectedTabPage = useRef<string>("1");
  const [_qtdy04_visible, set_qtdy04_visible] = useState(true);
  const _dt = useRef<any>();
  const noLineP = useRef<number>(0);
  const isYnEnd = useRef<boolean>(true);
  const _nm_rout_old = useRef<string>("");
  const _cd_item_old = useRef<string>("");
  const [gridFocus, setGridFocus] = useState(false);
  useRef<string>("");
  const [activeTab, setActiveTab] = useState("1");
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [selectedLineDocu, setSelectedLineDocu] = useState<number>(0);

  const woInfoRef = useRef({ cd_wo: "", st_wo: "" });
  const isProgrammaticChangeRef = useRef(false);
  //#endregion
  const cd_menu = Menuprops.cd_menu || "SN_PRD_WMO_REG_001_CHEM";
  const defaultSize = { panel1height: "45.5%", panel2height: "45.5%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
  const [btnText, setBtnText] = useState({
    send: "발행",
  });
  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
          grid4: rtn.grid.grid4,
        });
        const payload = {
          id: "recipeParam",
          params: {
            cd_firm: userInfo.cd_firm,
            cd_biz: rtn.formData.cd_biz,
          },
        };
        const data = await fnGetTableById(payload);
        setDataSources({
          grid1: [],
          grid2: [],
          grid3: [],
          grid4: [],
          paramInfo: data,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);
  useEffect(() => {
    if (gridFocus) {
      gridRefs.current["grid1"].current.selectAndFocusRow(0);
      setGridFocus(false);
    }
  }, [gridFocus]);

  useEffect(() => {
    if (
      Menuprops.figure &&
      columns.grid1.length > 0 &&
      columns.grid2.length > 0
    ) {
      onActivate(Menuprops.nodeData);
    }
  }, [columns, Menuprops]);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onPrint,
  }));
  //#region OnSearch
  const onSearch = async () => {
    try {
      const params = {
        id: "sn_prd_wmo_reg_001_chem_01",
        params: searchRef.current.getFormdata(),
      };
      setSelectedDocu("");

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      gridRefs.current["grid4"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
        grid3: data[2] || [],
        grid4: data[3] || [],
        paramInfo: data[4],
      });

      setGridFocus(true);
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#region OnInsert
  const onInsert = async () => {
    try {
      const searchForm = searchRef.current.getFormdata();
      if (searchForm.tp_wo === "") {
        showDialog("alter", "공정경로유형을 선택하시기 바랍니다.");
        return;
      }
      const newRow = {
        cd_firm: userInfo.cd_firm,
        cd_user_reg: userInfo.cd_user,
        cd_dept: userInfo.cd_dept,
        no_wo: "",
        cd_biz: userInfo.cd_biz,
        cd_gp: userInfo.cd_gp,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        dt_wo: todayform,
        tp_wo: searchForm.tp_wo,
        dt_start: todayform,
        dt_end: todayform,
        fg_wo: "ETC",
        qt_work: 0,
        qt_rcv: 0,
        qt_req: 0,
        qt_wo: 1,
        qt_divide: 1,
        no_line_so: 0,
        st_wo: "R",
        cd_wo: "",
        cd_rout: "",
        yn_autorcv: "Y", // 자동입고 디폴트 Y
      };
      let cdwhRow;
      if (gridRefs.current["grid1"].current.getDisplayedRowCount() !== 0) {
        const first_data =
          gridRefs.current["grid1"].current?.getRowNodeAtIndex(0);
        cdwhRow = {
          ...newRow,
          cd_wh: first_data.data.cd_wh,
          nm_wh: first_data.data.nm_wh,
        };
      } else {
        cdwhRow = { ...newRow, cd_wh: "", nm_wh: "" };
      }
      gridRefs.current["grid1"].current?.addRow(cdwhRow);
    } catch (error: any) {}
  };

  //#region OnDelete
  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() === 0) return;

    const selectedRows = gridRefs.current["grid1"].current.focusedRowNode();
    gridRefs.current["grid2"].current?.deleteAllRows();
    gridRefs.current["grid3"].current?.deleteAllRows();
    gridRefs.current["grid4"].current.applyFilters({
      no_wo: selectedRows.data.no_wo,
    });
    gridRefs.current["grid4"].current?.deleteAllRows();
    gridRefs.current["grid1"].current?.deleteSelectedRows();
    const realDeletedRows =
      gridRefs.current["grid1"].current?.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid1"].current?.resetUpdate();
      gridRefs.current["grid2"].current?.resetUpdate();
      gridRefs.current["grid3"].current?.resetUpdate();
      gridRefs.current["grid4"].current?.resetUpdate();
      return;
    }
  };
  const onPrint = async () => {
    gridRefs.current["grid1"].current?.stopEditing();
    gridRefs.current["grid2"].current?.stopEditing();
    const grid1 = gridRefs.current["grid1"].current?.focusedRowNode();
    const grid2 = gridRefs.current["grid2"].current?.focusedRowNode();
    gridRefs.current["grid1"].current?.resetUpdate();
    gridRefs.current["grid2"].current?.resetUpdate();
    // 결과 객체 반환
    return {
      cd_firm: userInfo.cd_firm,
      no_wo: grid1.data.no_wo,
      cd_op: grid2.data.cd_op,
    };
  };
  //#region OnDeleteRow
  const onDeleteRow = async () => {
    let rowCount;
    if (selectedTabPage.current === "1")
      rowCount = gridRefs.current["grid2"].current?.getDisplayedRowCount();
    else rowCount = gridRefs.current["grid3"].current?.getDisplayedRowCount();
    if (rowCount < 0) return;

    const selectedRows = gridRefs.current["grid1"].current.focusedRowNode();
    const st_wo = selectedRows.data.st_wo;
    let footerData2;
    if (selectedTabPage.current === "1")
      footerData2 = gridRefs.current["grid2"].current?.getFooterData();
    const qt_work = footerData2?.qt_work;
    if (selectedRows.data.no_wo !== "") {
      if (st_wo === "C") {
        showDialog("error", "지시상태 마감의 경우 행추가 하실 수 없습니다.");
        return;
      } else if (st_wo === "R") {
        if (
          selectedTabPage.current === "1" &&
          selectedRows.data.yn_autorel === "Y" &&
          qt_work > 0
        ) {
          showDialog(
            "error",
            "발행된 작업지시므로 행추가/행삭제 할 수 없습니다."
          );
          return;
        } else if (selectedRows.data.yn_autorel === "N") {
          showDialog(
            "error",
            "발행된 작업지시므로 행추가/행삭제 할 수 없습니다."
          );
          return;
        }
      }
    }

    if (selectedTabPage.current === "1") {
      gridRefs.current["grid2"].current?.deleteSelectedRows();
    } else {
      gridRefs.current["grid3"].current?.deleteSelectedRows();
    }
  };
  //#region onAddRow
  const onAddRow = async () => {
    try {
      const row = gridRefs.current["grid1"].current?.focusedRowNode();
      let selectedRows = gridRefs.current["grid1"].current.getSelectedRows()[0];
      const allRowData: any[] = []; // 라인에 있는 데이터들
      const allRowData2: any[] = []; // 라인에 있는 데이터들
      gridRefs.current["grid2"].current?.forEachFilteredNode((node: any) => {
        allRowData.push(node.data);
      });
      gridRefs.current["grid3"].current?.forEachFilteredNode((node: any) => {
        allRowData2.push(node.data);
      });
      const maxNoLine =
        gridRefs.current["grid2"].current.getMaxValue("no_line");
      const maxNoLine2 =
        gridRefs.current["grid3"].current.getMaxValue("no_line");
      if (selectedTabPage.current === "1") {
        const newRow = {
          qt_wo: row.data.qt_wo,
          qt_divide: row.data.qt_divide,
          cd_firm: userInfo.cd_firm,
          dt_dlv: todayform,
          no_line: maxNoLine + 1,
          yn_work: "Y",
          st_proc: woInfoRef.current.st_wo,
        };
        gridRefs.current["grid2"].current?.addRow(newRow);
      } else {
        const newRow = {
          qt_wo: row.data.qt_wo,
          qt_divide: row.data.qt_divide,
          cd_firm: userInfo.cd_firm,
          dt_dlv: todayform,
          no_line: maxNoLine2 + 2,
        };
        gridRefs.current["grid3"].current?.addRow(newRow);
      }
    } catch (error: any) {}
  };
  const onBeforeAddRowL3 = () => {
    try {
      return {};
    } catch (error: any) {
      return false;
    }
  };

  const onBeforeAddRowL4 = () => {
    try {
      return {};
    } catch (error: any) {
      return false;
    }
  };
  /*const onBeforeAddRowH = (newRow: RowData): boolean => {
    try {
      const prdWoChanges = gridApiRef1.current.getChange().insert;
      const searchParam = searchRef.current.getFormdata();
      if (prdWoChanges.length > 0) return false;

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_user_reg: userInfo.cd_user,
        cd_dept: userInfo.cd_dept,
        no_wo: "",
        cd_biz: userInfo.cd_biz,
        cd_gp: userInfo.cd_gp,
        cd_emp: userInfo.cd_emp,
        dt_wo: todayform,
        tp_wo: searchParam.tp_wo,
        dt_start: todayform,
        dt_end: todayform,
        fg_wo: "ETC",
        qt_work: 0,
        qt_rcv: 0,
        qt_req: 0,
        qt_wo: 1,
        qt_divide: 1,
        no_line_so: 0,
        cd_wo: woInfoRef.current.cd_wo,
        st_wo: woInfoRef.current.st_wo,
      };

      Object.assign(newRow, updatedRow);

      return true;
    } catch (error: any) {
      return false;
    }
  };*/
  //#region InitnewrowL
  /*const onBeforeAddRowL = (newRow: RowData): boolean => {
    try {
      if (
        !gridApiRef1 ||
        gridApiRef1.current.api.getSelectedNodes().length === 0
      ) {
        alert("선택된 행이 없습니다.");
        return false;
      }
      const requiredValuesCheckH = gridApiRef1.current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }

      return true;
    } catch (error: any) {
      return false;
    }
  };*/

  //#region OnSave
  const onSave = async () => {
    let woChemChanges;
    let woRecipeGroupChanges;
    let woRecipeChemChanges;
    let wobillChemChanges;

    try {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();
      gridRefs.current["grid3"].current?.stopEditing();
      gridRefs.current["grid4"].current?.stopEditing();

      // Validate required fields (Header)
      const requiredValuesCheckH =
        gridRefs.current["grid1"].current?.requiredValuesCheck();
      if (!requiredValuesCheckH) return;

      // Validate required fields (Line)
      const requiredValuesCheckL =
        gridRefs.current["grid2"].current?.requiredValuesCheck();
      if (!requiredValuesCheckL) return;

      // Get changes
      woChemChanges = gridRefs.current["grid1"].current?.getChange();
      woRecipeGroupChanges = gridRefs.current["grid2"].current?.getChange();
      wobillChemChanges = gridRefs.current["grid3"].current?.getChange();
      woRecipeChemChanges = gridRefs.current["grid4"].current?.getChange();
      if (
        woChemChanges.modifiedRowcount === 0 &&
        woRecipeGroupChanges.modifiedRowcount === 0 &&
        wobillChemChanges.modifiedRowcount === 0 &&
        woRecipeChemChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const headerInserts = woChemChanges.insert ?? [];
      const lineInserts2 = wobillChemChanges.insert;
      const lineInserts3 = woRecipeGroupChanges.insert;
      const lineInserts4 = woRecipeChemChanges.insert;
      //신규 등록된 수주건이 있는 경우 채번
      for (let row of headerInserts) {
        if (!row.no_wo) {
          const cd_module: any = Menuprops.cd_module;
          const cd_menu: any = Menuprops.cd_menu;
          try {
            // getNoSlip 호출
            const no_wo = await getNoSlip(
              cd_module,
              1, // no_line 값이 필요한 경우 사용
              "WMO", // cd_prefix 값이 필요하다면 여기에 적어주세요.
              row.dt_wo, // 해당 날짜를 넘겨줘야 할 경우
              cd_menu // cd_user 값
            );
            if (no_wo) {
              row.no_wo = no_wo; // no_so 값을 추가

              for (let row of lineInserts2) {
                if (!row.no_wo) {
                  if (no_wo) {
                    row.no_wo = no_wo; // no_so 값을 추가
                  }
                }
              }
              for (let row of lineInserts3) {
                if (!row.no_wo) {
                  if (no_wo) {
                    row.no_wo = no_wo; // no_so 값을 추가
                  }
                }
              }
              for (let row of lineInserts4) {
                row.qt_matl_adjust = row.qt_matl;
                if (!row.no_wo) {
                  if (no_wo) {
                    row.no_wo = no_wo; // no_so 값을 추가
                  }
                }
              }
              gridRefs.current["grid2"].current.applyFilters({
                no_wo: no_wo,
              });
              gridRefs.current["grid3"].current.applyFilters({
                no_wo: no_wo,
              });
              gridRefs.current["grid4"].current.applyFilters({
                no_wo: no_wo,
              });
            }
            if (row.no_style === null) row.no_style = "";
          } catch (error) {}
        }
      }
      const SaveData = {
        woChem: woChemChanges,
        woRecipeGroup: woRecipeGroupChanges,
        wobillChem: wobillChemChanges,
        woRecipeChem: woRecipeChemChanges,
      };
      await fnSave("SN_PRD_WMO_REG_001_CHEM_SAVE_01", SaveData);

      gridRefs.current["grid1"].current?.resetUpdate();
      gridRefs.current["grid2"].current?.resetUpdate();
      gridRefs.current["grid3"].current?.resetUpdate();
      gridRefs.current["grid4"].current?.resetUpdate();

      await onSearch();
      return true;
    } catch (error: any) {
      return false;
    }
  };
  //#endregion

  const onGrid4BtnsClick = async (id: string) => {
    if (id === "btnQt_matl_adjust") {
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      const focusedNodeL = gridRefs.current["grid4"].current.focusedRowNode();

      const payload = {
        id: "recipeGroup",
        params: {
          cd_firm: userInfo.cd_firm,
          no_wo: focusedNodeH.data.no_wo,
          cd_group: focusedNodeL.data.cd_group,
        },
      };
      // const data = await fnGetTableById(payload);

      let totalQtMatl = 0;
      gridRefs.current["grid4"].current?.forEachNode((node: any) => {
        if (
          node.data.no_wo === focusedNodeH.data.no_wo &&
          node.data.st_run === "C" &&
          node.data.qt_matl > 0
        )
          totalQtMatl += Number(node.data.qt_matl || 0);
      });
    }
  };
  const onBtnsClick = async (id: string) => {
    //#region BtnaddRow
    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    if (id === "addRow") {
      onAddRow();
    }
    //#region BtndeleteRow
    if (id === "deleteRow") {
      onDeleteRow();
    } else if (id === "btnSend") {
      if (btnText.send === "발행") {
        gridRefs.current["grid1"].current.setValueImmediately(
          focusedNodeH,
          "st_wo",
          "F"
        );
        await onSave();
      } else if (btnText.send === "발행취소") {
        if (
          focusedNodeH.data.st_wo === "C" ||
          focusedNodeH.data.st_wo === "S"
        ) {
          await showDialog(
            "warning",
            "진행 또는 마감 상태에서 발행 취소 불가합니다."
          );
        }
        gridRefs.current["grid1"].current.setValueImmediately(
          focusedNodeH,
          "st_wo",
          "R"
        );
        await onSave();
      }
    } else if (id === "btnDown") {
      const selectedNode =
        gridRefs.current["grid1"].current.getSelectedRows()[0];
      if (selectedNode.state !== "insert") {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }
      const selectedData = {
        dt: todayform,
      };
      const component = (
        <SN_PRD_WMO_REG_001_CHEM_POP_001 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "생산계획적용",
        children: component,
        validation: false,
        width: "70%",
        height: "80%",
      });
      if (!result || result === "close") return;
      const lineResult = result[1];
      const focusedRowNodeH =
        gridRefs.current["grid1"].current.focusedRowNode();
      lineResult.map((result: any) => {
        for (const key in result) {
          if (key === "cd_item") focusedRowNodeH.setDataValue(key, result[key]);
          else if (key === "qt_req")
            focusedRowNodeH.setDataValue("qt_wo", result[key]);
          else focusedRowNodeH.setDataValue(key, result[key], "noEvent");
        }
      });
    }
  };

  //#region Filter
  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      const no_wo = selectedRow.no_wo;
      gridRefs.current["grid2"].current?.applyFilters({ no_wo: no_wo });
      gridRefs.current["grid2"].current?.selectAndFocusRow(0);
      gridRefs.current["grid3"].current?.applyFilters({ no_wo: no_wo });
      gridRefs.current["grid3"].current?.selectAndFocusRow(0);
      gridRefs.current["grid4"].current?.applyFilters({ no_wo: no_wo });
      gridRefs.current["grid4"].current?.selectAndFocusRow(0);
      if (selectedRow.st_wo === "F") {
        setBtnText({
          send: "발행취소",
        });
      } else if (selectedRow.st_wo === "R") {
        setBtnText({
          send: "발행",
        });
      }
      setSelectedDocu(no_wo);
    } else {
      return;
    }
  };
  const onFocusedRowChangedL = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      const cd_group = selectedRow.cd_group;
      const no_wo = selectedRow.no_wo;
      const virtual = updateColumnsByFilter(
        columns.grid4,
        selectedRow.cd_grp_equip
      );
      gridRefs.current["grid4"].current.changeColumnReorderConfigs(virtual);
      gridRefs.current["grid4"].current?.applyFilters({
        no_wo: no_wo,
        cd_group: cd_group,
      });
      gridRefs.current["grid4"].current?.selectAndFocusRow(0);
    } else {
      return;
    }
  };

  const updateColumnsByFilter = (gridColumns: any[], equip: any) => {
    const filterArray = dataSources.paramInfo.filter(
      (item: any) => item.cd_equip === equip
    );

    const lastColumnIds = ["dc_rmk"]; // 맨 뒤로 보낸 컬럼

    const normalColumns: any[] = []; // dummy가 아닌 일반 컬럼들
    const sortedColumns: any[] = []; // no_seq로 정렬할 컬럼
    const finalColumns: any[] = []; // 무조건 맨 뒤로 갈 컬럼

    gridColumns.forEach((row: any) => {
      const matchedItem = filterArray.find(
        (filterItem: any) => filterItem.no_line_param == row.cd_column
      );

      // dummy가 아닌 값들은 원본 순서대로 유지하기 위해 그대로 push
      if (lastColumnIds.includes(row.cd_column)) {
        finalColumns.push({
          cd_column: row.cd_column,
          fg_visible: row.fg_visible,
        });
      } else if (row.cd_clas !== "dummy") {
        normalColumns.push({
          cd_column: row.cd_column,
          fg_visible: row.fg_visible,
        });
      }
      // dummy인 애들은 매칭 여부에 따라 데이터를 가공해서 모음
      else {
        if (matchedItem) {
          sortedColumns.push({
            cd_column: row.cd_column,
            nm_column: matchedItem.nm_param,
            fg_visible: "Y",
            no_seq: matchedItem.no_seq, // 정렬 기준
          });
        } else {
          sortedColumns.push({
            cd_column: row.cd_column,
            nm_column: row.cd_column,
            fg_visible: "N",
          });
        }
      }
    });

    sortedColumns.sort((a, b) => a.no_seq - b.no_seq);

    return [...normalColumns, ...sortedColumns, ...finalColumns];
  };
  // const onRowClicked3 = (event: any) => {
  //   isYnEnd.current = true;
  // };
  const onSelectionChanged = (event: any) => {
    isYnEnd.current = true;
  };
  const TabChangedEvent = async (index: any) => {
    selectedTabPage.current = index;
  };
  const onRowClicked = (event: any) => {
    _nm_rout_old.current = event.data?.cd_rout;
    _cd_item_old.current = event.data?.cd_item;
  };
  //#region CellChanged1
  const onCellValueChanged = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const selectedRows = searchRef.current.getFormdata();
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    if (colId === "cd_item") {
      const payload = {
        id: "recipeGroup",
        params: {
          cd_firm: userInfo.cd_firm,
          cd_biz: selectedRows.cd_biz,
          cd_item: rowData.cd_item,
        },
      };
      const data = await fnGetTableById(payload);
      if (data[0] === undefined) return;
      data.forEach((row: any) => {
        const newRow = {
          cd_firm: userInfo.cd_firm,
          no_wo: rowData.no_wo,
          cd_item: rowData.cd_item,
          cd_group: row.cd_group,
          nm_group: row.nm_group,
          cd_grp_equip: row.cd_grp_equip,
          no_seq_group: row.no_seq_group,
          dc_rmk: row.dc_rmk,
          st_run: "F",
        };
        gridRefs.current["grid2"].current?.addRow(newRow);
      });

      const boml = {
        id: "boml",
        params: {
          cd_firm: userInfo.cd_firm,
          cd_biz: selectedRows.cd_biz,
          cd_item: rowData.cd_item,
        },
      };
      const search_boml = await fnGetTableById(boml);
      const maxNoLine3 =
        gridRefs.current["grid3"].current.getMaxValue("no_line");
      search_boml.forEach((row: any, index: any) => {
        const newRow = {
          no_wo: rowData.no_wo,
          cd_firm: userInfo.cd_firm,
          cd_matl: row.cd_matl,
          nm_matl: row.nm_matl,
          qt_need: row.qt_need,
          dt_dlv: rowData.dt_wo,
          no_line: maxNoLine3 + index + 1,
        };
        gridRefs.current["grid3"].current?.addRow(newRow);
      });

      const recipe = {
        id: "recipe",
        params: {
          no_wo: rowData.no_wo,
          cd_firm: userInfo.cd_firm,
          cd_biz: selectedRows.cd_biz,
          cd_item: rowData.cd_item,
        },
      };
      const search_recipe = await fnGetTableById(recipe);

      const totalRtMatl = search_recipe.reduce(
        (sum: number, row: any) => sum + Number(row.rt_matl || 0),
        0
      );
      search_recipe.forEach((row: any, index: any, arr: any[]) => {
        const qtMatl =
          totalRtMatl !== 0
            ? rowData.qt_wo
              ? (rowData.qt_wo / totalRtMatl) * row.rt_matl
              : 0
            : 0;

        const newRow: any = {
          cd_firm: userInfo.cd_firm,
          no_wo: rowData.no_wo,
          no_line: row.no_line,
          cd_group: row.cd_group,
          no_seq: row.no_seq,
          fg_recipe: row.fg_recipe,
          cd_matl: row.cd_matl,
          nm_matl: row.nm_matl,
          rt_matl: row.rt_matl,
          st_run: "F",
          cd_equip: row.cd_equip,
          qt_matl: qtMatl,
          qt_matl_adjust: qtMatl,
          rt_tol: row.rt_tol,
          dc_rmk: row.dc_rmk,
          yn_end_group: index === arr.length - 1 ? "Y" : "N",
        };
        for (let i = 1; i <= 20; i++) {
          const key = String(i);
          newRow[key] = row[key];
        }
        gridRefs.current["grid4"].current?.addRow(newRow);
      });
      gridRefs.current["grid2"].current?.selectAndFocusRow(0);
    } else if (colId === "qt_wo") {
      let totalRtMatl = 0;
      gridRefs.current["grid4"].current?.forEachNode((node: any) => {
        if (node.data.no_wo === rowData.no_wo)
          totalRtMatl += Number(node.data.rt_matl || 0);
      });
      gridRefs.current["grid4"].current?.forEachNode((node: any) => {
        if (node.data.no_wo === rowData.no_wo) {
          const newQtMatl =
            totalRtMatl !== 0
              ? (rowData.qt_wo / totalRtMatl) * node.data.rt_matl
              : 0;
          node.setDataValue("qt_matl", newQtMatl, "noEvent");
          node.setDataValue("qt_matl_adjust", newQtMatl, "noEvent");
        }
      });
    } else if (colId === "cd_wo") {
      const payload = {
        id: "wotype",
        params: { cd_firm: userInfo.cd_firm, cd_wo: rowData.cd_wo },
      };
      const result = await fnGetTableById(payload);
      rowNode.setDataValue("yn_autorel", result[0].yn_autorel, "noEvent");
      rowNode.setDataValue("yn_autorcv", result[0].yn_autorcv, "noEvent");
    } else if (colId === "dt_wo") {
      rowNode.setDataValue("dt_start", rowData.dt_wo, "noEvent");
      rowNode.setDataValue("dt_end", rowData.dt_wo, "noEvent");
    }
  };
  const onCellValueChanged4 = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const selectedRows = searchRef.current.getFormdata();
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
  };
  //#region CellChanged2

  //#region onActivate
  const onActivate = async (nodeData: any) => {
    if (!nodeData) return;
    if ((Menuprops.figure as string) === "fg_drilldown.Search") {
      const selectedData = {
        cd_firm: nodeData.cd_firm,
        cd_biz: nodeData.cd_biz,
        dt_from: nodeData.dt_woreq,
        dt_to: nodeData.dt_woreq,
      };
      setFormData(selectedData);
      onSearch();
    } else if ((Menuprops.figure as string) === "fg_drilldown.Registration") {
      const modifiedRowsH = gridRefs.current["grid1"].current?.getChange();
      const modifiedRowsL = gridRefs.current["grid2"].current?.getChange();
      if (
        modifiedRowsH.modifiedRowcount > 0 ||
        modifiedRowsL.modifiedRowcount > 0
      ) {
        const confirm = await showDialog(
          "confirmCancel",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
        );
        if (confirm === true) {
          await onSave();
          await setDrilldown();
          return;
        } else if (confirm === false) {
          gridRefs.current["grid1"].current?.resetUpdate();
          gridRefs.current["grid2"].current?.resetUpdate();
          await setDrilldown();
          return;
        } else {
          return;
        }
      } else {
        await setDrilldown();
      }
    }
  };
  const [isDrilldownActive, setIsDrilldownActive] = useState(false);

  const setDrilldown = async () => {
    setIsDrilldownActive(true);
    const drill = {
      cd_firm: userInfo?.cd_firm,
      no_so: Menuprops.nodeData[0],
      no_line: Menuprops.nodeData[1],
    };

    const param = {
      id: "SN_PRD_WMO_REG_001_CHEM_searchrefso",
      params: drill,
    };
    const data = await fnGetDataSet(param);

    const headerResult = data[0];

    if (headerResult) {
      await onInsert();
      const rowCount =
        gridRefs.current["grid1"].current?.getDisplayedRowCount();
      const lastRowIndex = rowCount - 1;
      const lastRowNode =
        gridRefs.current["grid1"].current?.getRowNodeAtIndex(lastRowIndex);
      lastRowNode?.setSelected(true);
      if (lastRowNode) {
        for (const key in headerResult[0]) {
          if (headerResult[0][key]) {
            lastRowNode.setDataValue(key, headerResult[0][key]);
          }
        }
      }
    }
    setIsDrilldownActive(false);
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
          onRowClicked: onRowClicked,
          onCellValueChanged: onCellValueChanged,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onFocusedRowChanged: onFocusedRowChangedL,
        },
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
        events: {
          onSelectionChanged: onSelectionChanged,
          onBeforeAddRow: onBeforeAddRowL3,
        },
      },
      grid4: {
        columns: columns.grid4,
        dataSource: dataSources.grid4,
        events: {
          onSelectionChanged: onSelectionChanged,
          onBeforeAddRow: onBeforeAddRowL4,
          onCellValueChanged: onCellValueChanged4,
        },
      },
    }),
    [columns, dataSources]
  );
  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        />
      </div>
      <div className="flex flex-col h-full min-h-0 space-y-1.5">
        <SnResizable
          direction={"height"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{
              isEditable: true,
              rowSelection: "single",
              title: "작업지시",
            }}
            events={grids.grid1.events}
            header={[
              <SnTabHeader
                body={[
                  <SnButton
                    text={btnText.send}
                    onClick={() => {
                      onBtnsClick("btnSend");
                    }}
                  />,
                  <SnButton
                    text={"생산계획적용"}
                    onClick={() => {
                      onBtnsClick("btnDown");
                    }}
                  />,
                ]}
              />,
            ]}
          />
        </SnResizable>
        <div className="flex flex-1 min-h-0 gap-1.5">
          <div className="min-h-0 ag-theme-alpine" style={{ flex: "0 0 35%" }}>
            <SnTab
              titles={["작업그룹", "BOM"]}
              width={"100%"}
              onTabChanged={TabChangedEvent}
              header={[
                <SnTabHeader
                // body={[
                //     <SnButton
                //         text={"▲"}
                //          onClick={() => {
                //          onGrid1BtnsClick("btnUp");}}
                //     />,
                //     <SnButton
                //          text={"▼"}
                //          onClick={() => {
                //          onGrid1BtnsClick("btnDown");}}
                //     />]}
                />,
              ]}
              body={[
                <SnGrid
                  ref={gridRefs.current["grid2"]} // Grid Name
                  columnConfig={grids.grid2.columns} // 컬럼 설정 전달
                  rowData={grids.grid2.dataSource} // Datasource
                  etcProps={{ rowSelection: "single" }}
                  events={grids.grid2.events}
                />,
                <SnGrid
                  ref={gridRefs.current["grid3"]} // Grid Name
                  columnConfig={grids.grid3.columns} // 컬럼 설정 전달
                  rowData={grids.grid3.dataSource} // Datasource
                  etcProps={{ rowSelection: "single" }}
                />,
              ]}
            />
          </div>
          <div className="flex-1 min-h-0 ag-theme-alpine">
            <SnGrid
              ref={gridRefs.current["grid4"]} // Grid Name
              columnConfig={grids.grid4.columns} // 컬럼 설정 전달
              rowData={grids.grid4.dataSource} // Datasource
              etcProps={{ rowSelection: "single", title: "레시피" }}
              events={grids.grid4.events}
            />
          </div>
        </div>
        <SnFileUploadBox
          selectedDocu={selectedDocu}
          selectedLineDocu={selectedLineDocu}
        />
      </div>
    </div>
  );
  //#endregion
});

export default SN_PRD_WMO_REG_001_CHEM;
